import * as React from 'react';
import { CountdownTimer } from '@grandvisionhq/common';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import '@grandvisionhq/state';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

const CmsCountdownTimerDocument = ({ component  })=>{
    const { endDate , showCountdown , countdownText , url , layout  } = component.getParameters();
    return /*#__PURE__*/ React.createElement(CountdownTimer, {
        endDate: endDate,
        countdownText: countdownText,
        showCountdown: showCountdown,
        url: url,
        layout: layout
    });
};
var CmsCountdownTimerDocument$1 = compose(withBreakpointVisibility, withAnchor)(CmsCountdownTimerDocument);

export { CmsCountdownTimerDocument, CmsCountdownTimerDocument$1 as default };
//# sourceMappingURL=CountdownTimerDocument.js.map
